import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { useSetState } from "Helpers/Hooks";
import { useDispatch, useSelector } from "react-redux";
import {
  DESIGNER_BREAK_FRAME,
  DESIGNER_BREAK_FRAME_ACTION,
} from "Stores/actionTypes";
import * as R from "ramda";
import { DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import Input from "Components/Input/Input";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import showNotify from "Helpers/Notify";

function SelectBreakFrame() {
  const dispatch = useDispatch();
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [formValid, setFormValid] = useState({});
  const { breakFrame } = useSelector((state) => ({
    breakFrame: state.design.breakFrame,
  }));

  const [controls, setControls] = useSetState({
    designerBreakFrame: {
      type: "number",
      value: "0",
      validation: {
        required: true,
        isNumeric: true,
        min: 0,
        max: 100,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = () => {
    setShow(!show);
  };

  const onEnter = async () => {
    const _bf = JSON.parse(breakFrame);
    setControls({
      designerBreakFrame: {
        value: _bf.break_Frame,
        validation: {
          required: true,
          isNumeric: true,
          min: 0,
          max: _bf.max_Len,
        },
      },
    });
    setFormValid({ designerBreakFrame: _bf.break_Frame !== 0 ? true : false });
  };

  const onFinish = async () => {
    const { designerBreakFrame } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const _bf = JSON.parse(breakFrame);
      await dispatch({
        type: DESIGNER_BREAK_FRAME_ACTION,
        data: `{"Group_base":${_bf.Group_base},"Break_frame":${designerBreakFrame.value}}`,
      });
      handleDialog();
    } else {
      showNotify({
        text: "لطفاً اطلاعات را به درستی وارد کنید.",
        customClass: "error",
      });
    }
  };

  const onExit = async () => {
    await dispatch({
      type: DESIGNER_BREAK_FRAME,
      data: null,
    });
  };

  return (
    <>
      <MuiIconButton
        title={<Translator id="designerBreakFrameDialog" />}
        icon={<Icons.ArrowsExpandVertical />}
        onClick={handleDialog}
        disabled={!breakFrame}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={show}
        TransitionProps={{
          onEnter: onEnter,
          onExit: onExit,
        }}
        onClose={handleDialog}
        fullWidth
        maxWidth="sm"
      >
        <div className="dialogHeader">
          <p>{t("designerBreakFrameDialog")}</p>
        </div>
        <DialogContent style={{ overflow: "visible" }}>
          {Object.keys(controls).map((key, index) => {
            return (
              <Grid item xs={12} key={key + index}>
                <Input
                  setValue={setValue.bind(this)}
                  name={key}
                  validation={controls[key].validation}
                  label={<Translator id={key} />}
                  type={controls[key].type}
                  value={controls[key].value}
                />
              </Grid>
            );
          })}
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            onClick={onFinish}
            title={<Translator id="button_save" />}
          />
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SelectBreakFrame;
